
/**
 * Handles redirection for external links, hash links, portal routes, internal Frontity routing, and fallback navigation
 * @param {string} link - The URL or path to redirect to
 * @param {object} [actions={}] - Frontity actions object (optional, defaults to empty object)
 * @param {function} [closeDrawer] - Function to close drawer (optional, used in DrawerCategory.jsx)
 */
const handleRedirection = (link) => {
    if (link?.length > 0) {
        // Handle external links (starting with http) in a new tab
        if (link.startsWith('http')) {
            window.open(link, '_blank');
            return;
        } else {
            window.location.href = link;
            return;
        }
    }
};

export default {
    handleRedirection
};
